/**
 * Copyright IBM Corp. 2022, 2026
 */

import { ReactNode } from 'react'
import Image from 'next/legacy/image'
import s from './style.module.css'

interface ImageBlockProps {
	image: {
		url: string
		alt: string
		width: number
		height: number
	}
	caption?: string
}

export default function ImageBlock({ image, caption }: ImageBlockProps) {
	return (
		<Figure caption={caption}>
			<Image
				src={image.url}
				alt={image.alt}
				width={image.width}
				height={image.height}
			/>
		</Figure>
	)
}

interface FigureProps {
	children: ReactNode
	caption?: string
}

function Figure({ children, caption }: FigureProps) {
	if (caption)
		return (
			<figure className={s.figure}>
				{children}
				<figcaption className={s.caption}>
					<p>{caption}</p>
				</figcaption>
			</figure>
		)
	return <>{children}</>
}
